module.exports = __webpack_public_path__ + "img/banner3.b2681bd6.png";